import { html } from '/vendor/htm-preact.module.js';

/**
 * One figure with a minus and a plus.
 *
 * Replaces a row of preset buttons. A row only offers what somebody thought of
 * in advance — race to 3, 5, 7, 9, 11 and nothing else — and it grows wider
 * every time another value turns out to be wanted. A stepper offers every
 * value in the range and takes the same room whether that range is five long
 * or twenty.
 *
 * The figure is the point, so it is large and the buttons flank it. Both ends
 * stop rather than wrap: a clamp that silently jumped from the maximum back to
 * the minimum would be a way to set 15 seconds while aiming for 300.
 */
export function Stepper({ value, onChange, min, max, step = 1,
                          format, testid, label }) {
  const at = (v) => Math.min(max, Math.max(min, v));
  const set = (v) => { if (v !== value) onChange(v); };
  return html`
    <div class="stepper" data-testid=${testid}>
      <button class="secondary" type="button"
              aria-label=${`Less ${label || ''}`.trim()}
              data-testid=${`${testid}-down`}
              disabled=${value <= min}
              onClick=${() => set(at(value - step))}>−</button>
      <span class="stepval" data-testid=${`${testid}-value`}>
        ${format ? format(value) : value}
      </span>
      <button class="secondary" type="button"
              aria-label=${`More ${label || ''}`.trim()}
              data-testid=${`${testid}-up`}
              disabled=${value >= max}
              onClick=${() => set(at(value + step))}>+</button>
    </div>`;
}

/**
 * A native <select>.
 *
 * Deliberately native rather than a menu built out of divs: it is one tag, it
 * is reachable by keyboard and screen reader without any work, and on a phone
 * it opens the platform's own picker — which is a better list than anything
 * this app would draw, and does not run off the edge when a circle is called
 * something long.
 */
export function Combo({ value, onChange, options, testid, placeholder }) {
  return html`
    <select class="combo" data-testid=${testid} value=${value}
            onChange=${(e) => onChange(e.target.value)}>
      ${placeholder && html`<option value="">${placeholder}</option>`}
      ${options.map((o) => html`
        <option key=${o.id} value=${o.id}>${o.label}</option>`)}
    </select>`;
}
